module.exports = __webpack_public_path__ + "static/media/room_17.56903ab5.jpg";